import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useOperatorAuth } from "./operatorAuth";

/** Gate for the operator console. Unauthenticated visitors go to the operator login,
 *  carrying the attempted path + whether this was a mid-session expiry. */
export function RequireOperator({ children }: { children: ReactNode }) {
  const { isAuthenticated, sessionExpired } = useOperatorAuth();
  const location = useLocation();
  if (!isAuthenticated) {
    const from = `${location.pathname}${location.search}`;
    return <Navigate to="/operator/login" replace state={{ from, expired: sessionExpired }} />;
  }
  return <>{children}</>;
}
